const locale = "pl-PL";

export const formatNumber = (value?: number): string => {
  if (!value) return "-";
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};
